import React, { useState, useEffect } from "react";
import Body from "../../Common/Body";
import moment from "moment";
import ContentCard from "../../Common/Layout/ContentCard";
import useFetch from "../../../hooks/useFetch";
import PurchaseFilters from "./PurchaseFilters";
import { PurchaseTable } from "./PurchaseTable";

const Purchases = () => {
  moment.locale();
  const [maxPagination, setMaxPagination] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataFetched, setDataFetched] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({
    dateFrom: moment().startOf("month").format("YYYY-MM-DD"),
    dateUntil: moment().format("YYYY-MM-DD"),
  });

  const { get } = useFetch();

  useEffect(() => {
    setIsLoading(true);
    let url = `/reports/purchases?page=${currentPage}&`;
    Object.keys(filters).forEach((key) => {
      url += key + "=" + filters[key] + "&";
    });

    get(url)
      .then(async (res) => {
        setDataFetched(res);
        setMaxPagination(res.total);
      })
      .catch((e) => {
        console.log(e);
        throw new Error(e);
      })
      .finally(() => setIsLoading(false));
  }, [filters, currentPage]);

  const handleSelectedPage = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <Body title={"Reporte de compras"}>
        <ContentCard>
          <PurchaseFilters
            filters={filters}
            setFilters={setFilters}
          ></PurchaseFilters>
        </ContentCard>
        <ContentCard>
          <PurchaseTable
            filters={filters}
            setFilters={setFilters}
            isLoading={isLoading}
            maxPagination={maxPagination}
            currentPage={currentPage}
            purchases={dataFetched.purchases}
            handleSelectedPage={handleSelectedPage}
          ></PurchaseTable>
        </ContentCard>
      </Body>
    </>
  );
};

export default Purchases;
